<template>
    <div class="lookinfo">
        <Breadcrumb class="tablelist-header">
            <BreadcrumbItem to="/">{{type==='edit'?$t('global.common.edit',{defaultValue:'编辑'}):(type==='add'?$t('erp.product.new_add',{defaultValue:'添加'}):$t('global.common.query',{defaultValue:'查看'}))}}Amazon{{$t('erp.virtualstore.shiptemplate',{defaultValue:'发运模板'})}}</BreadcrumbItem>
        </Breadcrumb>
        <Alert class="padding-10">
            <span class="tip-p" v-html="$t('fbb.rechage.alert')"></span>
        </Alert>
        <div class="bg-fff shadow padding-right-20">
            <header class="detail-title">{{$t('global.common.base_information',{defaultValue:'基本信息'})}}</header>
            <Form :label-width="120" ref="form" :model="formData">
                <FormItem prop="name" :rules="required" :label="$t('fbb.accountmanage.template_name',{defaultValue:'模板名称'})">
                    <Input v-model="formData.name"/>
                </FormItem>
                <FormItem prop="orgWarehouseIds" :rules="required" :label="$t('erp.virtualstore.correspwarehouse',{defaultValue:'对应仓库'})">
                    <Select v-model="formData.orgWarehouseIds" filterable multiple>
                        <Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option>
                    </Select>
                </FormItem>
                <Row class="splitline">
                    <FormItem  class="pull-left" prop="safetyStock" :rules="required" :label="$t('erp.virtualstore.safeQuantity',{defaultValue:'安全库存'})">
                        <InputNumber style="width:160px;" v-model="formData.safetyStock" :min="0" />
                    </FormItem>
                    <FormItem  class="pull-left" prop="priority" :rules="required" :label="$t('bi.work.task_priority',{defaultValue:'优先级'})">
                        <InputNumber style="width:160px;" v-model="formData.priority"/>
                        <span class="color-error">{{$t('erp.virtualstore.hightnumpriority',{defaultValue:'数字越大，优先级越高'})}}</span>
                    </FormItem>
                </Row>
                <header class="detail-title">{{$t('fbb.expresspackage.baseinfo',{defaultValue:'基本信息'})}}</header>
                <FormItem :label="$t('erp.virtualstore.description',{defaultValue:'模板描述'})">
                    <Input v-model="formData.description"  type='textarea' :rows="4" :placeholder="$t('erp.virtualstore.morethanone',{defaultValue:'最多1000个字'})"/>
                </FormItem>
                <Row>
                    <Col span="8">
                    <FormItem prop="property" :rules="required" :label="$t('erp.virtualstore.property',{defaultValue:'模板属性'})">
                        <RadioGroup v-model="formData.property">
                            <Radio :rules="required" label="NORMAL">{{$t('fbb.bill.account_common',{defaultValue:'正常'})}}</Radio>
                            <!-- <Radio :rules="required" label="FBAONSTIE">FBAONSTIE</Radio> -->
                            <Radio :rules="required" label="SFP">SFP</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem prop="isDefault" :rules="required" :label="$t('erp.virtualstore.isDefault',{defaultValue:'默认模板'})" >
                        <RadioGroup v-model="formData.isDefault">
                            <Radio :rules="required" :label="1">{{$t('global.common.yes',{defaultValue:'是'})}}</Radio>
                            <Radio :rules="required" :label="0">{{$t('global.common.no',{defaultValue:'否'})}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                    <Col span="8">
                    <FormItem prop="status" :rules="required" :label="$t('erp.virtualstore.tempstatus',{defaultValue:'模板状态'})">
                        <RadioGroup v-model="formData.status">
                            <Radio :rules="required" label="ACTIVE">{{$t('global.common.effective', { defaultValue: '有效' })}}</Radio>
                            <Radio :rules="required" label="INACTIVE">{{$t('fbb.accountmanage.loss_effect', { defaultValue: "失效" })}}</Radio>
                        </RadioGroup>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                    <FormItem v-if="type=='add'" prop="accountFlag" :rules="required" :label="$t('erp.virtualstore.amazonaccount',{defaultValue:'亚马逊账号'})">
                        <Select v-model="formData.accountFlag" filterable :disabled="type==='edit'">
                            <Option v-for="item in accountFlag" :value="item.flag" :key="item.id">{{ item.title }}({{ item.flag }})</Option>
                        </Select>
                    </FormItem>
                    <FormItem v-else :label="$t('erp.virtualstore.amazonaccount',{defaultValue:'亚马逊账号'})">
                        <span>{{formData.accountFlag}}</span>
                    </FormItem>
                    </Col>
                    <Col span="24">
                    <FormItem prop="code" :rules="required" :label="$t('erp.virtualstore.amazonname',{defaultValue:'亚马逊模板名称'})">
                        <Input v-model="formData.code" :placeholder="$t('erp.virtualstore.nomorethanone',{defaultValue:'不超过100个字符'})"/>
                        <span class="color-error">{{$t('erp.virtualstore.writeamazontemplate',{defaultValue:'请填写亚马逊后台的发运模板名称'})}}</span>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <footer class="text-center padding-bottom-20">
                <Button type="primary" class="width-15per" @click="submit">{{$t('erp.distribution.confirm_submit',{defaultValue:'提交'})}}</Button>
                <Button class="width-15per" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Button>
            </footer>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import {
    HttpUpdateTemplate,
    HttpTemplate
} from '@/service/boss/allot';

export default {
    data() {
        return {
            loading: false,
            type: '',
            id: '',
            formData: {
                name: '',
                description: '',
                orgWarehouseIds: '',
                safetyStock: '',
                priority: '',
                accountFlag: '',
                code: '',
                property: 'NORMAL',
                status: 'ACTIVE',
                isDefault: 0,
            },
            required: [{
                required: true,
                message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
            }],
        }
    },
    created() {
        const route = this.$route;
        this.type = route.params.type;
        this.id = route.query.id;
        this.getDetail();
    },
    watch: {
        formData: {
            deep: true,
            handler(val) {
                this.$nextTick(() => {
                    if (val.property === 'SFP') val.isDefault = 0
                })
            }
        },

    },
    computed: {
        ...mapGetters('boss',['warehouses','accountFlag'])
    },
    methods: {
        cancel() {
            this.$router.push({ name: "templist" })
        },
        handleResponse(data) {
            const {
                id,
                name,
                description,
                safetyStock,
                priority,
                accountFlag,
                code,
                property,
                status,
                isDefault,
                flag,
            } = data;
            this.formData = {
                id,
                name,
                description,
                orgWarehouseIds: data.items.map((item) => {
                    return item.warehouseId;
                }),
                safetyStock,
                priority,
                accountFlag,
                code,
                property,
                status,
                isDefault,
                flag
            };
        },
        async getDetail() {
            if (this.type !== 'edit') return false;
            this.loading = true;
            HttpTemplate({
                id: this.id
            }).then(res => {
                this.handleResponse(res.data);
                this.loading = false;
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            })
        },
        async submit() {
            let valid = await this.$refs['form'].validate();
            if (!valid) return;
            this.loading = true;
            const accountId = this.accountFlag.filter((item) => {
                            return this.formData.accountFlag == item.flag;});
            let formData = { ...this.formData, orgWarehouseIds: this.formData.orgWarehouseIds.join(','), accountId : accountId[0].id, orgId : global.SYSID};
            HttpUpdateTemplate(formData).then(res => {
                this.$Message.success(res.message);
                this.cancel();
                this.loading = false;
            }, err => {
                this.errorMessage(err.message);
                this.loading = false;
            })
        }
    }
}
</script>
